export const errMsg = ' If the problem persists, please contact support at support@revolutiones.com.'

export const errMsgRefresh = ' Please refresh the page and try again.' + errMsg



// WEBPACK FOOTER //
// ./src/utils/supportErrMsg.js